<template>
  <div v-rect-loading="loading" class="job-list-filter">
    <div class="title">{{ titleI18nKey ? $t(titleI18nKey) : $t(`${i18nPrefix}.label.jobListFilter`) }}</div>
    <table class="table">
      <tr class="header">
        <th class="filter-name filter-table-title">{{ jobCustomFieldI18nKey ? $t(jobCustomFieldI18nKey) : $t(`${i18nPrefix}.label.jobFilter`) }}</th>
        <th class="action filter-table-title">{{ $t(`${i18nPrefix}.label.operation`) }}</th>
        <th class="sort filter-table-title">{{ $t(`${i18nPrefix}.label.sort`) }}</th>
      </tr>
      <draggable
        v-model="jobFilterList"
        tag="tbody"
        handle=".sort"
        animation="200"
        class="body"
      >
        <tr v-for="item in jobFilterList" :key="item.id">
          <td>{{ item.filterI18nName }}</td>
          <td class="action">
            <el-switch
              v-model="item[switchKey]"
              active-color="#13ce66"
              @change="handleSwitchChange(item)"
            />
          </td>
          <td class="sort"><i class="drag-btn iconfont iconMore"></i></td>
        </tr>
      </draggable>
    </table>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { addI18nProperty } from '@/i18n'
import _ from 'lodash'
import draggable from 'vuedraggable'

export default {
  components: {
    draggable
  },
  props: {
    switchKey: {
      type: String,
      default: 'is_used'
    },
    orderKey: {
      type: String,
      default: 'order'
    },
    allowOpenFieldCount: {
      type: String,
      default: '4'
    },
    allowAllField: {
      type: Boolean,
      default: false
    },
    isJdDisplay: {
      type: Boolean,
      default: false
    },
    titleI18nKey: {
      type: String,
      default: ''
    },
    jobCustomFieldI18nKey: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.company.customLandingPage',
      loading: false,
      jobFilterList: null
    }
  },
  computed: {

  },
  created () {
    this.getFilterList()
  },
  methods: {
    ...mapActions('company', ['getJobListFilterList', 'updateJobListFilterList']),
    async submit () {
      this.loading = true
      try {
        const params = {
          data: this.jobFilterList,
          order: _.chain(this.jobFilterList).map(item => item.id).reverse().value(),
          order_key: this.orderKey,
          switch_key: this.switchKey,
          allow_open_field_count: this.allowOpenFieldCount,
          allow_all_field: this.allowAllField
        }
        await this.updateJobListFilterList(params)
      } finally {
        this.loading = false
      }
    },
    async getFilterList () {
      this.loading = true
      try {
        const resp = await this.getJobListFilterList({ order_field: `-${this.orderKey}`, is_jd_display: this.isJdDisplay })
        if (resp) {
          this.jobFilterList = _.map(resp, (item) => {
            addI18nProperty(item, 'filterI18nName', 'cn_name', 'name')
            return item
          })
        }
      } finally {
        this.loading = false
      }
    },
    handleSwitchChange (item) {
      if (this.allowAllField) {
        return
      }
      const switchKey = this.switchKey
      const openList = _.filter(this.jobFilterList, item => item[switchKey])
      if (this.allowOpenFieldCount && openList?.length > _.parseInt(this.allowOpenFieldCount)) {
        item[switchKey] = false
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.filterCountLimitTip`, { count: this.allowOpenFieldCount }))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.job-list-filter {
  margin-top: 20px;
  .title {
    font-size: 20px;
  }

  .table {
    margin-top: 20px;
    border-collapse: collapse;
    border-spacing: 0;
    empty-cells: show;
    width: 100%;

    .header {
      border: 1px solid #b2b5b7;

      .filter-table-title {
        color: #626365;
        border: 1px solid #b2b5b7;
        text-align: center;
        background: #ddd;
        padding: 10px;
        font-size: 12px;
        font-weight: normal;
      }
    }

    .body {
      tr {
        border: 1px solid #b2b5b7;
        vertical-align: middle;

        td {
          padding: 10px;
          text-align: left;
          font-weight: normal;
          vertical-align: middle;
          word-break: normal;
          border: 1px solid #b2b5b7;

          &.action {
            text-align: center;
          }

          &.sort {
            font-size: 20px;
            font-weight: 700;
            text-align: center;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
